import React from "react";
import "./Payable.css";
import { BiTrash } from "react-icons/bi";
import { FiEdit } from "react-icons/fi";

const Payable = () => {
  return (
    <>
      <div className="payable">
        <div className="lms-table-div view-loandetails">
          <table className="lms-table">
            <thead>
              <tr>
                <th>Loan ID</th>
                <th>Unique Number</th>
                <th>Borrower Name</th>
                <th>Staff Code</th>
                <th>Amount</th>
                <th>Reason</th>
                <th>Collection Date</th>
                <th>Reference Number</th>
                <th>Source</th>
                <th>Date of Refund</th>
                <th>Refund Via</th>
                <th>Refund Reference Number</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>37667</td>
                <td>CR11455</td>
                <td>ANC TEST</td>
                <td>UTPL999</td>
                <td>1000</td>
                <td>Excess</td>
                <td>25-6-2023</td>
                <td>12345</td>
                <td>UPI</td>
                <td>27-6-2023</td>
                <td>UPI</td>
                <td>12345</td>
                <td className="loan-details-table-icons">
                  <BiTrash style={{ marginRight: "20px" }} />
                  <FiEdit />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Payable;
